function GonganBeian() {
    return(
        <div style={{width:300,marginTop:0,marginBottom:0,marginLeft:"auto",marginRight:"auto",paddingTop:20,paddingBottom:20,paddingLeft:0,paddingRight:0}}>
            <a target="_blank" rel="noreferrer" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010402000646" style={{display:"inline-block",textDecoration:"none",height:20}}>
                    <img src="https://images.zh-cn.cc/beian.png" alt="公网安备" style={{float:"left"}}/><p style={{float:"left",marginTop:0,marginRight:0,marginBottom:0,marginLeft:5,height:20,color:"#939393"}}>蒙公网安备 15010402000646号</p>
            </a>
        </div>
    );
}
export default GonganBeian;